import { struct } from 'io-ts/Decoder';

import { Id as UsageId } from '../../../../whole-house/usage/Id';

export const Params = struct({
	usageId: UsageId,
});
